import { render } from "./AddModal_Kojin.vue?vue&type=template&id=e2f90566"
import script from "./AddModal_Kojin.vue?vue&type=script&lang=js"
export * from "./AddModal_Kojin.vue?vue&type=script&lang=js"

import "./AddModal_Kojin.vue?vue&type=style&index=0&id=e2f90566&lang=css"

import exportComponent from "/codebuild/output/src327471177/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__